import { NdbxIconModule } from "@allianz/ngx-ndbx/icon";
import { TextFieldModule } from "@angular/cdk/text-field";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
import { GoogleMapsModule } from "@angular/google-maps";
import { RouterModule } from "@angular/router";
import { NxAccordionModule } from "@aposin/ng-aquila/accordion";
import { NxActionModule } from "@aposin/ng-aquila/action";
import { NxAutocompleteModule } from "@aposin/ng-aquila/autocomplete";
import { NxBadgeModule } from "@aposin/ng-aquila/badge";
import { NxErrorModule } from "@aposin/ng-aquila/base";
import { NxBreadcrumbModule } from "@aposin/ng-aquila/breadcrumb";
import { NxButtonComponent } from "@aposin/ng-aquila/button";
import { NxButtonModule } from "@aposin/ng-aquila/button";
import { NxCardModule } from "@aposin/ng-aquila/card";
import { NxCheckboxModule } from "@aposin/ng-aquila/checkbox";
import { NxContextMenuModule } from "@aposin/ng-aquila/context-menu";
import { NxCopytextModule } from "@aposin/ng-aquila/copytext";
import { NxDataDisplayModule } from "@aposin/ng-aquila/data-display";
import {
  NxDatefieldModule,
  NxNativeDateModule,
} from "@aposin/ng-aquila/datefield";
import { NxDropdownModule } from "@aposin/ng-aquila/dropdown";
import { NxFormfieldModule } from "@aposin/ng-aquila/formfield";
import { NxGridModule } from "@aposin/ng-aquila/grid";
import { NxHeaderModule } from "@aposin/ng-aquila/header";
import { NxHeadlineModule } from "@aposin/ng-aquila/headline";
import { NxIconModule } from "@aposin/ng-aquila/icon";
import { NxIndicatorModule } from "@aposin/ng-aquila/indicator";
import { NxInputModule } from "@aposin/ng-aquila/input";
import { NxLinkModule } from "@aposin/ng-aquila/link";
import { NxListModule } from "@aposin/ng-aquila/list";
import { NxMenuModule } from "@aposin/ng-aquila/menu";
import { NxMessageModule } from "@aposin/ng-aquila/message";
import { NxModalModule } from "@aposin/ng-aquila/modal";
import { NxNaturalLanguageFormModule } from "@aposin/ng-aquila/natural-language-form";
import { NxNumberStepperModule } from "@aposin/ng-aquila/number-stepper";
import { NxPageSearchModule } from "@aposin/ng-aquila/page-search";
import { NxPaginationModule } from "@aposin/ng-aquila/pagination";
import { NxPopoverComponent } from "@aposin/ng-aquila/popover";
import { NxPopoverModule } from "@aposin/ng-aquila/popover";
import { NxProgressStepperModule } from "@aposin/ng-aquila/progress-stepper";
import { NxProgressbarModule } from "@aposin/ng-aquila/progressbar";
import { NxRadioModule } from "@aposin/ng-aquila/radio-button";
import { NxRadioToggleModule } from "@aposin/ng-aquila/radio-toggle";
import { NxSpinnerModule } from "@aposin/ng-aquila/spinner";
import { NxSwipebarModule } from "@aposin/ng-aquila/swipebar";
import { NxSwitcherModule } from "@aposin/ng-aquila/switcher";
import { NxTableModule } from "@aposin/ng-aquila/table";
import { NxTabsModule } from "@aposin/ng-aquila/tabs";
import { NxTaglistModule } from "@aposin/ng-aquila/taglist";
import { TranslateModule } from "@ngx-translate/core";

import { ExternalScrollbarModule } from "./modules/external-scrollbar/external-scrollbar.module";
import { SyncScrollModule } from "./modules/sync-scroll/sync-scroll.module";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ExternalScrollbarModule,
    FormsModule,
    GoogleMapsModule,
    NdbxIconModule,
    NxAccordionModule,
    NxActionModule,
    NxAutocompleteModule,
    NxBadgeModule,
    NxBreadcrumbModule,
    NxButtonModule,
    NxCardModule,
    NxCheckboxModule,
    NxContextMenuModule,
    NxCopytextModule,
    NxDataDisplayModule,
    NxDatefieldModule,
    NxDropdownModule,
    NxErrorModule,
    NxErrorModule,
    NxFormfieldModule,
    NxGridModule,
    NxHeaderModule,
    NxHeadlineModule,
    NxIconModule,
    NxIndicatorModule,
    NxInputModule,
    NxLinkModule,
    NxListModule,
    NxMenuModule,
    NxMessageModule,
    NxModalModule.forRoot(),
    NxNativeDateModule,
    NxNaturalLanguageFormModule,
    NxNaturalLanguageFormModule,
    NxNumberStepperModule,
    NxPageSearchModule,
    NxPaginationModule,
    NxPopoverModule,
    NxProgressStepperModule,
    NxProgressbarModule,
    NxRadioModule,
    NxRadioToggleModule,
    NxSpinnerModule,
    NxSwipebarModule,
    NxSwitcherModule,
    NxTableModule,
    NxTabsModule,
    NxTaglistModule,
    ReactiveFormsModule,
    RouterModule,
    SyncScrollModule,
    TextFieldModule,
    TranslateModule,
  ],
  exports: [
    CommonModule,

    ExternalScrollbarModule,
    FormsModule,
    NdbxIconModule,
    NxAccordionModule,
    NxActionModule,
    NxAutocompleteModule,
    NxBadgeModule,
    NxBreadcrumbModule,
    NxButtonComponent,
    NxButtonModule,
    NxCardModule,
    NxCheckboxModule,
    NxContextMenuModule,
    NxCopytextModule,
    NxDataDisplayModule,
    NxDatefieldModule,
    NxDropdownModule,
    NxErrorModule,
    NxFormfieldModule,
    NxGridModule,
    NxHeaderModule,
    NxHeadlineModule,
    NxIconModule,
    NxIndicatorModule,
    NxInputModule,
    NxLinkModule,
    NxListModule,
    NxMenuModule,
    NxMessageModule,
    NxModalModule,
    NxNativeDateModule,
    NxNaturalLanguageFormModule,
    NxNaturalLanguageFormModule,
    NxNumberStepperModule,
    NxPageSearchModule,
    NxPageSearchModule,
    NxPaginationModule,
    NxPopoverComponent,
    NxPopoverModule,
    NxProgressStepperModule,
    NxProgressbarModule,
    NxRadioModule,
    NxRadioToggleModule,
    NxSpinnerModule,
    NxSwipebarModule,
    NxSwitcherModule,
    NxTableModule,
    NxTabsModule,
    NxTaglistModule,
    ReactiveFormsModule,
    RouterModule,
    SyncScrollModule,
    TextFieldModule,
    TranslateModule,
  ],
})
export class SharedModule {}
